import React, { useEffect, useRef } from 'react';
import { useUserLoginInfoContext } from 'authentication/authentication-outer/UserLoginInfo/UserLoginInfoContext';
import { hasValidAuthSession } from 'helpers/authSession';
import { useLogoutUser } from 'helpers/logout';

const AuthProtected = (props) => {
  /*
    redirect is un-auth access protected routes via url
  */

  const userLoginInfo = useUserLoginInfoContext();
  const logout = useLogoutUser();
  const isAuthenticated = hasValidAuthSession(userLoginInfo);
  const didLogoutRef = useRef(false);

  useEffect(() => {
    if (!isAuthenticated && !didLogoutRef.current) {
      didLogoutRef.current = true;
      logout();
    }
    if (isAuthenticated) {
      didLogoutRef.current = false;
    }
  }, [isAuthenticated]);

  if (!isAuthenticated) {
    return null;
  }

  return <>{props.children}</>;
};

export { AuthProtected };
